import type { Recipe } from '../types';
import { isNameOnlyRecipeContent } from './temporaryRecipe';

export function buildDuplicateRecipeForHousehold(
    source: Recipe,
    targetHouseholdId: string,
    ownerId: string,
): Omit<Recipe, 'id'> {
    const now = new Date().toISOString();
    const isTemporary = source.isTemporary === true
        || isNameOnlyRecipeContent(source.ingredients ?? [], source.instructions);
    return {
        ...source,
        householdId: targetHouseholdId,
        ownerId,
        derivedFromRecipeId: source.id,
        sharedWithHouseholds: [],
        isPublic: false,
        isTemporary,
        createdAt: now,
        updatedAt: now,
        averageRating: undefined,
        ratingCount: undefined,
    };
}
